var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessEmpty1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 156,
    viewBox: "0 0 419 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11597_13981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 42,
    width: 285,
    height: 80,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 82,
    r: 24,
    fill: "url(#paint0_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 58,
    width: 75,
    height: 16,
    rx: 8,
    fill: "url(#paint1_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 58,
    width: 75,
    height: 16,
    rx: 8,
    fill: "url(#paint2_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 90,
    width: 167,
    height: 16,
    rx: 8,
    fill: "url(#paint3_linear_11597_13981)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11597_13981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 342,
    height: 80,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 67,
    r: 24,
    fill: "url(#paint4_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 43,
    width: 103.5,
    height: 16,
    rx: 8,
    fill: "url(#paint5_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.5,
    y: 43,
    width: 103.5,
    height: 16,
    rx: 8,
    fill: "url(#paint6_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 75,
    width: 224,
    height: 16,
    rx: 8,
    fill: "url(#paint7_linear_11597_13981)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11597_13981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 373,
    height: 80,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 51,
    r: 24,
    fill: "url(#paint8_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 27,
    width: 119,
    height: 16,
    rx: 8,
    fill: "url(#paint9_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 27,
    width: 119,
    height: 16,
    rx: 8,
    fill: "url(#paint10_linear_11597_13981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 59,
    width: 255,
    height: 16,
    rx: 8,
    fill: "url(#paint11_linear_11597_13981)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11597_13981",
    x: 44.9412,
    y: 31.7059,
    width: 329.118,
    height: 124.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.7647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0294
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11597_13981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11597_13981",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11597_13981",
    x: 15.9412,
    y: 16.7059,
    width: 386.118,
    height: 124.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.7647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0294
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11597_13981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11597_13981",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11597_13981",
    x: 0.941177,
    y: 0.705883,
    width: 417.118,
    height: 124.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.7647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0294
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11597_13981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11597_13981",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11597_13981",
    x1: 115,
    y1: 58,
    x2: 98.5,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11597_13981",
    x1: 209.134,
    y1: 58.0001,
    x2: 152.868,
    y2: 59.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11597_13981",
    x1: 301.134,
    y1: 58.0001,
    x2: 244.868,
    y2: 59.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11597_13981",
    x1: 268.179,
    y1: 90.0001,
    x2: 143.134,
    y2: 96.1491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11597_13981",
    x1: 86,
    y1: 43,
    x2: 69.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11597_13981",
    x1: 198.425,
    y1: 43.0001,
    x2: 120.812,
    y2: 45.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11597_13981",
    x1: 318.925,
    y1: 43.0001,
    x2: 241.312,
    y2: 45.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11597_13981",
    x1: 275.761,
    y1: 75.0001,
    x2: 108.359,
    y2: 86.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11597_13981",
    x1: 71,
    y1: 27,
    x2: 54.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11597_13981",
    x1: 193.373,
    y1: 27.0001,
    x2: 104.163,
    y2: 30.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11597_13981",
    x1: 329.373,
    y1: 27.0001,
    x2: 240.163,
    y2: 30.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11597_13981",
    x1: 280.657,
    y1: 59.0001,
    x2: 90.3308,
    y2: 73.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessEmpty1);
export default __webpack_public_path__ + "static/media/business-empty-1.5545797416aa19f5596a46d76707ea06.svg";
export { ForwardRef as ReactComponent };